module.exports = __webpack_public_path__ + "images/screenshot2.gif";